import gql from "graphql-tag";

export const userFragment = gql`
  fragment UserFragment on User {
    id
    firstName
    lastName
    email
    avatarUrl
    active
    phoneNumber
  }
`;

export const employeeFragment = gql`
  fragment EmployeeFragment on User {
    ...UserFragment
    workDayHours
    region
  }
  ${userFragment}
`;
